module.exports = __webpack_public_path__ + "static/media/USDHKD.d46ca3e8.svg";